import React, { useState, Fragment, useEffect } from "react";
import { Table, Button } from "reactstrap";
import ModalGroup from "../../../Profile/Modal/ModalGroup";
import ModalConfirm from "../../Modal/ModalConfirm";
//import { LoadingMessage } from "../../Controls";
import LaddaButton, { ZOOM_OUT, XS } from "react-ladda";
import { CircularProgress } from "../../../..";
import { getAccountType } from "../types";
//import { Mode, WizzMode } from "../../types";
import { AccountMode } from "../../../../utils/Helper";
//import { useEntities } from "../../Wizzard";

const GroupsTab = ({ accountId, groups, isReadOnly, setAccountData, services, role, mode }) => {
  //const [readonly, setReadonly] = useState(mode == WizzMode.View);
  const [modalGroup, setModalGroup] = useState({ open: false });
  const [fetching, setFetching] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    groupId: undefined,
    saving: false,
  });
  //const [deleting, setDeleting] = useEntities({});

  const toggle = (props) => {
    setModalGroup({ open: !modalGroup.open, ...props });
  };

  const toggleModalConfirm = () => {
    setModalConfirm({
      open: false,
      title: "",
      groupId: undefined,
      value: undefined,
      saving: false,
    });
  };

  // handle grid actions
  const handleAction = (action, group, value) => {
    if (action == "Insert") {
      toggle({
        accountId,
        action,
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == "Update") {
      toggle({
        accountId,
        action,
        group: groups.find((c) => c.AccountGroupId == group && c.AccountGroupValue == value),
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == "Delete") {
      setModalConfirm({
        open: true,
        title: "Are you sure you want to delete the selected group Account?",
        groupId: group,
        value: value,
      });
    }
  };

  useEffect(() => {
    if (role && role == 'Onboarding') {
    if (mode === AccountMode.New) {
          if (!fetching) {
            const body = {
              AccountGetInfo: {
                GetAccountDataId: accountId,
                GetAccountDataOnboardingId: accountId,
                GetAccountDataType: getAccountType.Groups,
              },
            };
            services.fetchNewAccountInfo(body, (response) => {
              if (response && response.SDTAccount) {
                setAccountData(
                  {
                    AccountId: accountId,
                    Groups: response.SDTAccount.Groups,
                  },
                  false
                );
              }
              let toggleDWOpen = [];
              if (response && response.SDTAccount) {
                toggleDWOpen = response.SDTAccount.Groups.map(() => false);
              }

              setFetching(false);
            });
            setFetching(true);
          }
        }}
      }, []);

  const handleSave = (a, fields) => {
    const account = {
      [role === 'Onboarding' ? 'AccountOnboardingId' : 'AccountId']: accountId,
      Groups: [
        {
          AccountGroupId: fields.AccountGroupId,
          AccountGroupName: fields.AccountGroupName,
          AccountGroupValue: fields.AccountGroupValue,
          AccountGroupAction: a
        },
      ],
    };
    const body = {
      account,
      accountChangeType: getAccountType.Groups,
    };
    //setModalBankAccount({...modalBankAccount, saving: true});
    services.fetchAccountUpdate(body, (response) => {
      if (response && response.result && response.result.Code === 200) {
        const newBankAccounts = [...groups];
        let index = -1;
        newBankAccounts.map((bankAcc, i) => {
          if (fields.AccountGroupId === bankAcc.AccountGroupId) {
            index = i;
          }
          return {};
        });
        if (index > -1) {
          newBankAccounts[index] = fields;
        } else {
          newBankAccounts.push(fields);
        }
        account.Groups = newBankAccounts;
        setAccountData(account, true);
        setModalGroup({ open: !modalGroup.open, ...modalGroup });
      } else {
        setModalGroup({ open: !modalGroup.open, ...modalGroup });
        alert(response.result.Description);
      }
    });
  };

  const handleDelete = () => {
    const groupid = modalConfirm.groupId;
    const value = modalConfirm.value;
    const account = {
      [role === 'Onboarding' ? 'AccountOnboardingId' : 'AccountId']: accountId,
      Groups: [
        {
          AccountGroupId: groupid,
          AccountGroupValue: value,
          DeleteGroup: true,
        },
      ],
    };
    const body = {
      account,
      accountChangeType: getAccountType.Groups,
    };
    setModalConfirm({ ...modalConfirm, saving: true });
    services.fetchAccountUpdate(body, (response) => {
      if (response && response.result && response.result.Code === 200) {
        const newBankAccounts = [...groups];
        let index = -1;
        newBankAccounts.map((bankAcc, i) => {
          if (groupid === bankAcc.AccountGroupId) {
            index = i;
          }
          return {};
        });
        if (index > -1) {
          newBankAccounts.splice(index);
        }
        account.Groups = newBankAccounts;
        setAccountData(account, true);
        toggleModalConfirm();
      } else {
        setModalConfirm({
          ...modalConfirm,
          saving: false,
        });
        alert(response.result.Description);
      }
    });
  };

  useEffect(() => {
    if (!groups && !fetching) {
      const body = {
        AccountGetInfo: {
          GetAccountDataId: accountId,
          GetAccountDataType: getAccountType.Groups,
        },
      };
      services.fetchAccountSectorInfo(body, (response) => {
        if (response && response.SDTAccount) {
          setAccountData(
            {
              AccountId: accountId,
              Groups: response.SDTAccount.Groups,
            },
            false
          );
        }
        setFetching(false);
      });
      setFetching(true);
    }
  }, [groups, fetching, accountId, setAccountData, services]);

  return (
    <div>
      {!isReadOnly && (
        <Button color="primary" className="mb-3" onClick={() => handleAction("Insert")}>
          <i className="fa fa-plus mr-1" aria-hidden="true"></i>
          Add Account group
        </Button>
      )}
      <Table>
        <thead>
          <tr>
            <th>Group Name</th>
            <th>Group Value</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {groups ? (
            <Fragment>
              {groups.map((item) => (
                <tr key={`set-${item.AssetGroupId}-${item.AssetGroupValue}`}>
                  <td>{item.AccountGroupName}</td>
                  <td>{item.AccountGroupValue}</td>
                  <td>
                    {!isReadOnly && (
                      <Actions
                        id={item.AccountGroupId}
                        valueId={item.AccountGroupValue}
                        action={handleAction}
                        // deleting={
                        //   !!deleting[
                        //     `${item.AssetGroupId}-${item.AssetGroupValue}`
                        //   ]
                        // }
                      />
                    )}
                  </td>
                </tr>
              ))}
              {groups.length == 0 && <EmptyOrLoading />}
            </Fragment>
          ) : (
            <EmptyOrLoading loading={true} />
          )}
        </tbody>
      </Table>
      <ModalConfirm {...modalConfirm} toggle={ModalConfirm} callback={handleDelete} />
      <ModalGroup {...modalGroup} toggle={toggle} services={services} />
    </div>
  );
};

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="3">
      {loading ? (
        <CircularProgress text="Loading groups" />
      ) : (
        <span className="text-center d-block h5 m-3" style={{ textAlign: "center" }}>
          No Account groups
        </span>
      )}
    </td>
  </tr>
);

const Actions = ({ action, id, valueId, deleting }) => (
  <div className="d-flex justify-content-end">
    <Button color="primary" size="sm" className="mr-2" onClick={() => action("Update", id, valueId)}>
      <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
    </Button>

    <LaddaButton
      className="btn btn-ladda btn-danger btn-sm"
      loading={deleting}
      onClick={() => action("Delete", id, valueId)}
      data-style={ZOOM_OUT}
      data-size={XS}
    >
      <i className="fa fa-trash-o" aria-hidden="true"></i>
    </LaddaButton>
  </div>
);

export default GroupsTab;
